import IL_ILCE from "@/lib/ilIlce.json";
import VERGI_DAIRELERI from "@/lib/vergiDaireleri.json";
import { trAra } from "@/components/ortak/Liste";

export { IL_ILCE, VERGI_DAIRELERI };
export const ILLER = Object.keys(IL_ILCE).sort((a, b) => a.localeCompare(b, "tr"));
export const PERSONEL_TIP = { serbest: "Serbest Çalışan", tam_zamanli: "Tam Zamanlı Çalışan", yari_zamanli: "Yarı Zamanlı Çalışan" };
export const PAZARYERLERI = ["stockmount", "trendyol", "hepsiburada", "n11", "amazon", "pazarama", "çiçeksepeti", "ciceksepeti", "woocommerce", "idefix", "pttavm", "pazaryeri"];
export const pazaryeriMi = (c) => (c.etiketler || []).some((e) => PAZARYERLERI.includes(trAra(e)));
export const SEKMELER = [
  { k: "genel", ad: "Genel Cariler", kategori: "genel" },
  { k: "pazaryeri", ad: "Pazaryeri Carileri", kategori: "genel" },
  { k: "potansiyel", ad: "Potansiyel Müşteriler", kategori: "potansiyel" },
  { k: "personel", ad: "Personel Cariler", kategori: "personel" },
  { k: "is_ortagi", ad: "İş Ortakları", kategori: "is_ortagi" },
  { k: "maas", ad: "Tekrarlı Maaşlar" },
];
export const secenek = (l) => l.map((x) => ({ value: x, label: x }));
export const etiketleri = (c) => (c.etiketler?.length ? c.etiketler : c.grup ? [c.grup] : []);
